<template>
  <div>
    <b-modal
      id="confirmRemoveAllAiAttractions"
      modal-class="modal-cover"
      v-model="isVisible"
      hide-backdrop
      hide-footer
      content-class="shadow-lg"
    >
      <section class="text-center" :dir="isHebrew ? 'rtl' : 'ltr'">
        <b-row>
          <b-col cols="12" class="py-2">
            <h3 class="font-weight-medium card-title">
              {{ t(titleKey) }}
            </h3>
            <p class="confirm-remove-all__note">
              {{ t('aiChatConfirmRemoveAllNote') }}
            </p>
          </b-col>

          <b-col cols="12" class="py-2">
            <ul class="confirm-remove-all__list">
              <li v-for="(title, i) in titles" :key="i">{{ title }}</li>
            </ul>
          </b-col>

          <b-col cols="12" class="py-2">
            <b-btn
              pill
              variant="danger"
              class="px-5 py-2 text-white"
              @click="confirmRemoveAll"
              >{{ t(confirmKey) }} ({{ titles.length }})</b-btn
            >
            <b-btn
              pill
              variant="success"
              class="px-5 py-2 text-white"
              @click="closePopup"
              >{{ t('removeAttractionCancelButton') }}</b-btn
            >
          </b-col>
        </b-row>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from '@/mixins/translationMixin';

export default {
  props: ["value"],
  mixins: [translationMixin],

  computed: {
    ...mapGetters(['inerModalParameters']),
    titles() {
      const params = this.inerModalParameters;
      return (params && params.titles) || [];
    },
    // "Accept all changes" reuses this modal to list what it will remove.
    titleKey() {
      const params = this.inerModalParameters;
      return (params && params.titleKey) || 'aiChatConfirmRemoveAllTitle';
    },
    confirmKey() {
      const params = this.inerModalParameters;
      return (params && params.confirmKey) || 'aiChatRemoveAll';
    },
    isVisible: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    ...mapActions(['showModal']),
    confirmRemoveAll() {
      // showModal('') clears inerModalParameters, so grab the callback first.
      const params = this.inerModalParameters;
      const onConfirm = params && params.onConfirm;
      this.showModal('');
      if (onConfirm) onConfirm();
    },
    closePopup() {
      this.showModal('');
    },
  },
};
</script>

<style scoped>
.modal.modal-cover .modal-content,
.modal.modal-cover .modal-footer,
.modal.modal-cover .modal-header {
  border: none;
}
.confirm-remove-all__note {
  font-size: 14px;
  color: #a71d2a;
  margin: 8px 0 0;
}
.confirm-remove-all__list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  text-align: start;
}
.confirm-remove-all__list li {
  padding: 6px 12px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}
.confirm-remove-all__list li:last-child {
  border-bottom: none;
}
</style>
